module.exports = __webpack_public_path__ + "static/img/KYNAN-BROWN.dc2391a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KYNAN-BROWN.jpg
// module id = OS12
// module chunks = 0